import type { DocumentReference as FhirDocumentReference } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '../ui/skeleton';
import { DocumentReference } from './DocumentReference';

export type RequisitionDocumentsSectionProps = {
  documents: FhirDocumentReference[] | undefined;
  isLoading: boolean;
};

/**
 * Renders Health Gorilla `LabOrderRequisition` `DocumentReference` PDFs alongside
 * a lab order. Looked up by HG requisition identifier upstream — see
 * `getHealthGorillaRequisitionId` in `@liza/fhir-utils`.
 */
export const RequisitionDocumentsSection = ({
  documents,
  isLoading,
}: RequisitionDocumentsSectionProps): React.ReactElement => {
  const { t } = useTranslation('records');

  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">{t('requisitionDocument')}</h2>
      {isLoading && <Skeleton className="h-[600px] w-full" />}
      {!isLoading && (!documents || documents.length === 0) && (
        <p className="text-sm text-muted-foreground">{t('noRequisitionDocuments')}</p>
      )}
      {!isLoading && documents?.map((doc, idx) => <DocumentReference key={doc.id ?? idx} documentReference={doc} />)}
    </section>
  );
};
